import { render, staticRenderFns } from "./SalesVolume.vue?vue&type=template&id=6c434a96"
import script from "./SalesVolume.vue?vue&type=script&lang=js"
export * from "./SalesVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports